<template>
  <ul
    v-if="validationStatus && validationStatus.$error"
    class="a-input-message a-input-message--error js-a-input-message--error filled"
  >
    <li
      v-for="$error in validationStatus.$errors"
      :key="$error.$property"
      class="a-input-message__error-item js-a-input-message__error-item"
    >
      {{ $error.$message }}
    </li>
  </ul>
</template>

<script>
export default {
  name: "ErrorMessage",
  props: {
    validationStatus: {
      type: Object,
      required: true
    },
  }
}
</script>
